/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import queryString from 'query-string'

import './styles.scss'

class QuerySummary {
  constructor (element) {
    this.$el = $(element)

    this.$activeFilterTemplate = $(this.$el.find('.querySummary-activeFilterTemplate').html())
    this.$summaryWrapper = this.$el.find('.querySummary-summaryWrapper')

    // without the collection cancel button
    this.$singleText = this.$el.find('.querySummary-singleText')
    this.$pluralText = this.$el.find('.querySummary-pluralText')
    this.$singleText.remove()
    this.$pluralText.remove()

    // with the collection cancel button
    this.$singleCollectionText = this.$el.find('.querySummary-singleCollectionText')
    this.$pluralCollectionText = this.$el.find('.querySummary-pluralCollectionText')
    this.$singleCollectionText.remove()
    this.$pluralCollectionText.remove()

    this.showCollectionTerm = (window.collectionSettings && window.collectionSettings.show_collection_term)
  }

  showQuerySummary (term, count) {
    let $summaryText = null
    let summaryTextHTML = ''

    this.$summaryWrapper.html('')

    if (this.showCollectionTerm) {
      if (count === 1) {
        $summaryText = this.$singleCollectionText.clone()
      } else {
        $summaryText = this.$pluralCollectionText.clone()
      }
    } else {
      if (count === 1) {
        $summaryText = this.$singleText.clone()
      } else {
        $summaryText = this.$pluralText.clone()
      }
    }

    summaryTextHTML = $summaryText.html()
    summaryTextHTML = summaryTextHTML.replace('{{ count }}', count)
    summaryTextHTML = summaryTextHTML.replace('{{ terms }}', '<span>' + decodeURIComponent(term) + '</span>')

    $summaryText.html(summaryTextHTML)
    this.$summaryWrapper.append($summaryText)

    if (this.showCollectionTerm) {
      const $collectionTermButton = this.$activeFilterTemplate.clone()
      $collectionTermButton.find('.activeFilterButton-text').html(window.collectionSettings.title)

      $collectionTermButton.on('click', () => {
        window.location = this.$el.attr('data-root-url') + `?q=${term}`
      })
      this.$summaryWrapper.append($collectionTermButton)
    }

    this.$el.removeClass('u--hide')
  }
}

registerClass('QuerySummary', QuerySummary)
